import {
  Card,
  CardHeader,
  Stack,
  Button,
  ButtonGroup,
  Tooltip,
} from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useState, useEffect } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";
import FileUpload from "../pages/Utils/FileUpload";

import { FaCloudDownloadAlt } from "react-icons/fa";
import { apicall } from "../Integration/apicall";
import { getalldepartment, getalltechnicalfeedback, getjobids } from "./query";
import { FaFilter } from "react-icons/fa6";
import { IoRefreshCircle } from "react-icons/io5";
import ReusableFilter from "../ReusableFilter";

const TechiInterviewTable = () => {
  const nav = useNavigate();

  const [Department, SetDepartment] = useState([]);
  const [filterparam, setfilterparam] = useState([]);

  const [openfilter, setopenfilter] = useState(false);

  const [departmentdata, setdepartmentdata] = useState([]);
  const [Staffdata, setStaffdata] = useState([]);
  const [Status, setStatus] = useState({ value: "" });
  const [tabledata, settabledata] = useState([]);
  const [Sampledata, setSampledata] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({
    value: "All",
    label: "All",
  });
  const [jobid, setjobid] = useState();
  const [SelecteJobID, setSelecteJobID] = useState({
    value: "All",
    label: "All",
  });
  const [alljobid, setalljobid] = useState([]);

  const [feedbackid, setfeedbackid] = useState([]);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  useEffect(() => {
    fetchtechnicalfeedback();
    onDepartmentSubmit();
    OnStaffRequest();
    // Fetchfeedback();
  }, []);

  const downloadCV = async (cvFile) => {
    console.log("cvFile:", cvFile);

    let CvName = cvFile.split("/").pop();

    console.log("CvName:", CvName);

    const downloadButton = document.getElementById("downloadButton");
    if (downloadButton) downloadButton.style.display = "none";

    try {
      const fileUrl = `${FileUpload}${cvFile}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const fileUrlObject = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileUrlObject;
      link.download = CvName;
      link.click();

      URL.revokeObjectURL(fileUrlObject);
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      if (downloadButton) downloadButton.style.display = "inline-block";
    }
  };

  const TableColumn = [
    {
      field: "jobid",
      headerName: "Job ID",
      width: 130,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "candidateName",
      headerName: "Candidate Name",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "totalExperience",
      headerName: "Total Experience",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "expectedCtc",
      headerName: "Expected CTC",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "currentEmployer",
      headerName: "Current Emp",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "interviewAvailability",
      headerName: "Availability",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "hiringstatus",
      headerName: "Status",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "cv",
      headerName: "Download CV",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
  ];

  const handlechange = (event, setevent) => {
    console.log(setevent.name + "settev");

    if (setevent.name == "department") {
      const cloneddepartment = { ...Department };
      cloneddepartment.value = event;
      SetDepartment(cloneddepartment);
    } else if (setevent.name == "status") {
      const clonedstatus = { ...Status };
      clonedstatus.value = event;
      console.log(clonedstatus + "clonedstatus");
      setStatus(clonedstatus);
    } else {
      const clonedjobid = { ...jobid };
      clonedjobid.value = event;
      setjobid(clonedjobid);
    }
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const departmentList = response.data.data.allDepartment;
      console.log("departmentList:", departmentList);

      setdepartmentdata(departmentList);
      // setallDepartment({
      //   ...allDepartment,
      //   departmentnames: departmentList,
      // });
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const OnStaffRequest = async () => {
    const query = `query {
  allStaffRequests {
    id
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
    
  }
}`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      let result = response.data.data.allStaffRequests;
      console.log("resultresult:", result);

      setStaffdata(result);
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  useEffect(() => {
    Promise.all([apicall(getalldepartment), apicall(getjobids)]).then(
      ([departmentdata, jobdata]) => {
        console.log("department res", departmentdata?.data?.data);
        console.log("job res", jobdata?.data?.data);
        let departments = departmentdata?.data?.data?.allDepartment;
        let jobs = jobdata?.data?.data?.allStaffRequests;
        console.log(jobs, "alljobs found");

        jobs = jobs?.map((job) => ({
          value: job?.jobid,
          label: job?.jobid,
          field: "jobid",
        }));

        departments = departments?.map((department) => ({
          value: department?.departmentName,
          label: department?.departmentName,
          field: "department",
        }));

        setfilterparam([
          {
            field: "JobId",
            options: jobs,
          },
          {
            field: "department",
            options: departments,
          },
        ]);
      },
    );
  }, []);

  const fetchtechnicalfeedback = () => {
    apicall(getalltechnicalfeedback)
      .then((res) => {
        if (res?.success) {
          let alltechnicalfeedback =
            res.data?.data?.allSelectedCandidatesWithFeedback.filter(
              (item) => item?.manuallyAdd === false,
            );
          console.log(alltechnicalfeedback, "inside ress");
          alltechnicalfeedback = alltechnicalfeedback.map((feedback, ind) => ({
            technicaldata: feedback?.technicalFeedback?.[0] || {},
            // id: feedback?.technicalFeedback?.[0]?.id || 0,
            id: ind + 1,
            feedbackid: feedback?.technicalFeedback?.[0]?.id || 0,
            jobid: feedback?.jobid,
            sourcingid: feedback?.id,
            candidateName: feedback?.candidateName,
            position: feedback?.position,
            interviewdate: feedback?.interviewAvailability,
            department: feedback?.department,
            interviewer: feedback?.interviewer,
            totalExperience: feedback?.totalExperience,
            expectedCtc: feedback?.expectedCtc,
            currentCtc: feedback?.currentCtc,
            currentEmployer: feedback?.currentEmployer,
            interviewAvailability: feedback?.interviewAvailability?.slice(
              0,
              10,
            ),
            hiringstatus:
              feedback?.technicalFeedback?.[0]?.hiringStatus || "Pending",
            cv: (
              <>
                <FaCloudDownloadAlt
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the event from propagating
                    downloadCV(feedback.cvFile); // Pass the file name or URL
                  }}
                  style={{ fontSize: "25px" }}
                >
                  Download CV
                </FaCloudDownloadAlt>
              </>
            ),
          }));
          console.log(alltechnicalfeedback, "alltechfeed");

          settabledata(alltechnicalfeedback);
        } else {
        }
      })
      .catch((err) => {});
  };

  const onRowClick = (e) => {
    console.log("Click:", e.row);
    const {
      id,
      candidateName,
      jobid,
      technicaldata,
      interviewdate,
      position,
      department,
      interviewer,
      sourcingid,
      feedbackid,
    } = e.row;
    const specific_technicalfeedback = {
      ...technicaldata,
      candidateName,
      feedbackid,
      jobid,
      interviewdate,
      position,
      department,
      interviewer,
      sourcingid,
    };

    nav(`/technical/feedback`, { state: specific_technicalfeedback });
  };

  const handleclosefilter = () => {
    setopenfilter(false);
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                // spacing={2}
                // margin={1}
              >
                <Stack direction="row" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Technical Interview
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>

                <Stack direction="row">
                  <ButtonGroup variant="outlined" size="small" color="#000">
                    <Tooltip title="Filter the table" disableInteractive arrow>
                      <MaterialButton onClick={() => setopenfilter(true)}>
                        <FaFilter size={16} color="black" />
                      </MaterialButton>
                    </Tooltip>
                    <Tooltip
                      title="Refresh/Reset the table"
                      disableInteractive
                      arrow
                    >
                      <MaterialButton onClick={fetchtechnicalfeedback}>
                        <IoRefreshCircle size={20} color="black" />
                      </MaterialButton>
                    </Tooltip>
                  </ButtonGroup>
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={tabledata}
          columns={TableColumn}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No technical interview found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any technical interview details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
        <ReusableFilter
          filterparam={filterparam}
          setfilterparam={setfilterparam}
          setfilterdata={settabledata}
          openfilter={openfilter}
          handleclosefilter={handleclosefilter}
          unfiltereddata={tabledata}
        />
      </Card>
    </DashboardLayout>
  );
};
export default TechiInterviewTable;
